//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { uid, extend } from "quasar";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    name: "ExposeApiRuleEditor",
    components: {
        setConditions, AQModal, AQInput, AQDropdown, AQDialog, AQCard
    },
    props: {
        ruleId: { type: String, default: "" },
        rulesParentArray: { type: Array, default: () => [] },
        selectedFields: { type: Array, default: () => [] }
    },
    data() {
        return {
            editRulesModal: true,
            invalidName: false,
            extendParent: false,
            editMode: false,
            conditionExistance: false,
            message: "",
            codeChanged: false,
            initialCode: "",
            initialMess: "",
            warningDialog: false,
            currentRule: {
                name: "",
                description: "",
                conditions: {},
                error: {
                    code: "400",
                    message: ""
                }
            },
            copyRuleInfo: {
                name: "",
                description: "",
                conditions: {},
                error: {
                    code: "400",
                    message: ""
                }
            },
            rulesOpts: [{ label: this.$t("diagrams.components.exposeApi.errorType"), value: "400" },
                { label: this.$t("diagrams.components.exposeApi.errorType2"), value: "418" },
                { label: this.$t("diagrams.components.exposeApi.errorType3"), value: "500" }]
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        getRuleId() {
            return this.ruleId;
        },
        headerActionsModel() {
            return this.editMode
                ? [{
                    label: this.$t("diagrams.components.setRules.delete"),
                    id: "deleteRule"
                }]
                : [];
        },
        hasSave() {
            return {
                label: this.editMode ? this.$t("diagrams.components.exposeApi.updateBtn") : this.$t("diagrams.components.exposeApi.addBtn"),
                disabled: !this.conditionExistance
            };
        }
    },
    watch: {
        currentRule: {
            deep: true,
            handler(value) {
                if (value && value.conditions.conditions && value.conditions.conditions.length && this.checkValidConditions()) {
                    this.conditionExistance = true;
                } else {
                    this.conditionExistance = false;
                }
            }
        }

    },

    created() {
        if (this.rulesParentArray.length) {
            for (let i = 0; i < this.rulesParentArray.length; i++) {
                if (this.rulesParentArray[i].uuid === this.getRuleId) {
                    this.currentRule = extend(true, {}, this.rulesParentArray[i]);
                    this.copyRuleInfo = extend(true, {}, this.currentRule);
                    this.editMode = true;
                }
            }
        }
        this.setErrorMessage();
    },
    methods: {
        defineRequestAction(action) {
            if (action === "save") {
                if (this.currentRule.name) {
                    this.invalidName = false;
                    this.uuid = this.currentRule.uuid ? this.currentRule.uuid : uid();
                    this.$emit("rulesEditorList", {
                        uuid: this.uuid,
                        name: this.currentRule.name,
                        index: 0,
                        description: this.currentRule.description,
                        conditions: this.currentRule.conditions,
                        error: {
                            code: this.currentRule.error.code,
                            message: this.message
                        }
                    });
                    this.editRulesModal = false;
                    this.$emit("input", false);
                    this.$emit("closeRuleEditorModal");
                } else {
                    this.invalidName = true;
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("diagrams.components.setRules.ruleNameRequired")
                    });
                    // aici se face apelul metodei de verificare a conditiilor din set-levels
                }
            } else if (action === "close") {
                if (!this.checkIfIsEmpty()) {
                    if ((JSON.stringify(this.copyRuleInfo) !== JSON.stringify(this.currentRule)) || (this.copyRuleInfo.error.message !== this.message)) {
                        this.warningDialog = true;
                    } else {
                        this.editRulesModal = false;
                        this.$emit("input", false);
                        this.$emit("closeRuleEditorModal");
                    }
                } else {
                    this.editRulesModal = false;
                    this.$emit("input", false);
                    this.$emit("closeRuleEditorModal");
                }
            } else if (action === this.$t("diagrams.components.setRules.delete")) {
                const ruleIndex = this.rulesParentArray.findIndex(element => element.uuid === this.currentRule.uuid);
                if (ruleIndex !== -1) {
                    // eslint-disable-next-line
                    this.rulesParentArray.splice(ruleIndex, 1);
                }
                this.editRulesModal = false;
                this.$emit("input", false);
                this.$emit("closeRuleEditorModal");
            }
        },
        okDialog() {
            this.currentRule = extend(true, {}, this.copyRuleInfo);
            this.editRulesModal = false;
            this.$emit("input", false);
            this.$emit("closeRuleEditorModal");
        },
        cancelDialog() {
            this.editRulesModal = true;
        },
        checkIfIsEmpty() {
            return !this.currentRule.name
            && !this.currentRule.description
            && this.message === "Bad Request"
            && !this.currentRule.error.message && !this.checkValidConditions();
        },
        afterHide() {
            this.$emit("input", false);
        },
        changeErrorCode(value) {
            switch (value) {
                case "400": this.message = this.$t("diagrams.components.exposeApi.error400"); break;
                case "418": this.message = this.$t("diagrams.components.exposeApi.error418"); break;
                case "500": this.message = this.$t("diagrams.components.exposeApi.error500"); break;
                default: break;
            }
            this.codeChanged = true;
        },
        setErrorMessage(evt) {
            let value = null;
            if (evt && evt.length) {
                value = evt[0].value;
                this.currentRule.error.code = value;
            }
            if (!value && this.currentRule.error.message) {
                this.initialCode = this.currentRule.error.code;
                this.initialMess = this.currentRule.error.message;
                this.message = this.currentRule.error.message;
            } else if (!value && !this.currentRule.error.message) {
                this.changeErrorCode(this.currentRule.error.code);
            } else if (value && this.currentRule.error.code === this.initialCode) {
                this.message = this.currentRule.error.message;
            } else {
                this.changeErrorCode(this.currentRule.error.code);
            }
        },

        checkMessage() {
            this.currentRule.message = this.message;
            if (this.currentRule.name && this.checkValidConditions() && this.message) {
                this.conditionExistance = true;
            }
        },

        // metoda care verifica conditiile care vin din set-levels sa nu fie empty
        checkValidConditions() {
            let isValid = true;
            if (this.currentRule.conditions && this.currentRule.conditions.conditions) {
                this.currentRule.conditions.conditions.forEach(condition => {
                    if (condition.type === "condition" && (condition.val1.value === "" || condition.val2.value === "")) {
                        isValid = false;
                    }
                });
            }
            if (this.currentRule.conditions && this.currentRule.conditions.conditions && !this.currentRule.conditions.conditions.length) {
                isValid = false;
            }
            if (JSON.stringify(this.copyRuleInfo) === JSON.stringify(this.currentRule)) {
                isValid = false;
            }
            return isValid;
        }

    }
};
